import { useState } from "react";
import storageManager from "../Utility/StorageManager";

const useLocalState = (key, initialState) => {
  const [state, setState] = useState(JSON.parse(storageManager.getItem(key) ?? JSON.stringify(initialState)));

  const stateSetter = (newState) => {
    storageManager.setItem(key, JSON.stringify(newState));
    setState(newState);
  };

  return [state, stateSetter];
};

export default useLocalState;
